// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2EE2L","inputWrap":"Table_inputWrap__3FGdV","col":"Table_col__UtS54","bmiTooltip":"Table_bmiTooltip__2QR26"};